module.exports = __webpack_public_path__ + "img/planet-earth-internal.7fce947c.svg";